import React, { FC, useEffect } from 'react';
import { Card, CardContent, Container, Stack, Typography } from '@mui/material';
import MetbusLogo from 'src/components/MetbusLogo';
import VersionDisplayer from 'src/components/shared/VersionDisplayer';
import { Link as RouterLink } from 'react-router-dom';
import InspectorModal from 'src/pages/authentication/components/inspectorAccount/InspectorModal';
import { LoginType } from 'src/types/loginData';
import useAuth from 'src/hooks/useAuth';
// import { requestAccessByIP } from 'src/api/authenticate';
import LogoDT from 'src/icons/LogoDT';
import iconStyles from 'src/components/css/iconStyle';
import useSettings from 'src/hooks/useSettings';
import { THEMES } from 'src/constants';
import LoginContainer from 'src/pages/authentication/components/LoginContainer';

const LoginInspector: FC = () => {
  // const [loading, setLoading] = useState<boolean>(false);
  const { setLoginType } = useAuth();
  const { settings } = useSettings();
  let contrastColor = false;
  if (settings.theme === THEMES.METBUSLIGHT) {
    contrastColor = true;
  }

  useEffect(() => {
    // getIpData();
    setLoginType(LoginType.INSPECTOR);
  }, []);

  return (
    <LoginContainer>
      <Container
        maxWidth="xs"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          gap: '2rem',
          height: '100%',
        }}
      >
        {/* {loading && <AccountLoader isInspector />} */}
        <Card
          sx={{
            width: '350px',
            height: 'auto',
            boxShadow: 1,
            transition: 'all 400ms ease',
            '&:hover': {
              transition: 'all 400ms ease-in',
              boxShadow: 2,
            },
            '@media screen and (max-width: 374px)': {
              width: '260px',
            },
          }}
        >
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: 4,
              gap: '1rem',
            }}
          >
            <Stack
              direction={'column'}
              alignItems={'center'}
              gap={'1rem'}
            >
              <MetbusLogo
                height="72"
                width="240"
                contrastColor={contrastColor}
              />
              <Typography
                color="textSecondary"
                variant="body2"
                mb={2}
              >
                Acceso Dirección del Trabajo
              </Typography>
            </Stack>
            <LogoDT
              sx={{
                ...iconStyles,
                minHeight: '170px',
                minWidth: '170px',
                pr: '2rem',
              }}
            />
            <InspectorModal />
            <Typography
              component={RouterLink}
              to="/loginMailInspector"
              color="textPrimary"
              sx={(theme) => ({
                fontSize: '0.875rem',
                textDecoration: 'none',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginLeft: 'auto',
                // transition: 'all 0.3s ease',
                cursor: 'pointer',
                '&:hover': {
                  color: theme.palette.primary.main,
                },
              })}
            >
              Tengo una clave vigente
            </Typography>
          </CardContent>
        </Card>
        <VersionDisplayer horizontal />
      </Container>
    </LoginContainer>
  );
};

export default LoginInspector;
